// server-clock.ts — how far the browser's clock is from the database server's.
//
// A QR channel's lease is written with the server's clock. Judging it against the browser's clock
// reports an outage on a fast clock and hides one on a slow clock. The offset is measured each time
// the sessions are read (the request's midpoint against the server's answer) and every status that
// depends on time uses `serverNow()`. Until a measurement exists the browser clock is used.

let offsetMs = 0;

/** Record a server timestamp received between `sentAt` and `receivedAt` (browser clock, ms). */
export function setServerClock(serverTimeIso: string, sentAt: number, receivedAt: number): void {
  const server = Date.parse(serverTimeIso);
  if (Number.isNaN(server)) return;
  offsetMs = server - (sentAt + receivedAt) / 2;
}

export function serverNow(): number {
  return Date.now() + offsetMs;
}

export function serverClockOffsetMs(): number {
  return offsetMs;
}

/** Test hook: forget the measurement. */
export function resetServerClock(): void {
  offsetMs = 0;
}
